module.exports = __webpack_public_path__ + "static/media/LocalGlobal.5bc800d0.gif";